"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@cimpress/react-components");

var Spinner = _reactComponents.shapes.Spinner;

var WrappedSpinner = function WrappedSpinner(_ref) {
  var showSpinner = _ref.showSpinner,
      spinnerClassName = _ref.spinnerClassName,
      spinnerSize = _ref.spinnerSize,
      children = _ref.children;

  if (showSpinner) {
    return /*#__PURE__*/_react["default"].createElement(Spinner, {
      size: spinnerSize,
      className: spinnerClassName
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};

var _default = WrappedSpinner;
exports["default"] = _default;
WrappedSpinner.propTypes = {
  showSpinner: _propTypes["default"].bool,
  spinnerClassName: _propTypes["default"].string,
  spinnerSize: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
WrappedSpinner.defaultProps = {
  showSpinner: false,
  spinnerClassName: undefined,
  spinnerSize: 'medium'
};